module.exports = __webpack_public_path__ + "static/media/link.f3a0d8df.svg";